import React from "react";
import AsyncComponent from "../../../components/async-component";
import PageWrap from "../../../components/page-wrap";
import PageContent from "../../../components/page-content";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import { MainProvider } from "./context/MainContext";

class OffersAppPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <MainProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </MainProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OffersAppPage;
